log = require 'loglevel'
Tween = require 'tween'
BaseButton = require 'BaseButton'
SingleScratchView = require 'singleScratchView'
currencyManager = require 'currencyManager'
eventManager = require 'eventManager'
imageManager = require 'imageManager'
layoutManager = require 'layoutManager'
realityManager = require 'realityManager'
gameModel = require 'gameModel'
imageModel = require 'imageModel'


# Simply match three symbols and with a little luck of the Irish, the prize can be yours!

class MenuView extends PIXI.Container

  name: 'MenuView'
  winningPrizes: []
  updateCallback: null
  timer: null
  canClick: false
  completed: false

  isRootView: true
  characterMovement: -150

  textY: 140

  #----------------------------------------------

  setup: ->

    @characterX = gameModel.characterX
    @characterY = gameModel.characterY
    @characterZ = gameModel.characterZ
    @style = gameModel.styles.introText
    @transitionSpeed = gameModel.transitionSpeed


    @addLogo()
    @addCharacter() if gameModel.showCharacter
    @addButtons()
    @addTagline()
    @zSort()

    setTimeout(=>
      @playButton.reset()

      if (not gameModel.isOutOfTickets() and not gameModel.isOutOfFunds()) or gameModel.showBuyMoreButton
        @playButton.enable()
      else
        @playButton.disable()

    ,1)

  #----------------------------------------------

  addLogo: (cb) ->
    # log.info @constructor.name, 'addLogo'

    if @logo?
      @logo.visible = true
    else
      logoY = gameModel.logoYTitle
      if gameModel.logoFromBottomTitle
        logoY = gameModel.rendererHeight - gameModel.logoYTitle

      url = imageModel.logoTitleImage
      imageManager.loadAsset url, (image) =>
        @logo = new PIXI.Sprite.fromImage url
        @logo.anchor.set 0.5
        @logo.x = gameModel.gameWidth/2
        @logo.y = logoY
        @logo.z = gameModel.logoZTitle
        @addChild @logo
        cb() if cb?

  #----------------------------------------------

  addTagline: ->

    maxPrize = gameModel.getMaxPrize()
    maxPrize = currencyManager.localize maxPrize
    tagline = __t.str("introtext", {maxPrize: maxPrize})
    @tagline = new PIXI.Text tagline, @style
    x = Math.round((gameModel.gameWidth-@tagline.width)/2)
    @tagline.x = (gameModel.gameWidth - @tagline.width)/2
    @tagline.y = gameModel.rendererHeight - @textY
    @tagline.z = gameModel.taglineZ
    @addChild @tagline

    @tagline.clarify()

  # -------------------------------------------

  addCharacter: ->

    if @character?
      @character.visible = true
    else
      url = imageModel.characterImage
      imageManager.loadAsset url, (image) =>
        @character = new PIXI.Sprite.fromImage url
        @character.x = @characterX
        @character.y = 0
        @character.z = @characterZ
        @character.scale.set(gameModel.characterScale) if gameModel.characterScale?
        @addChild @character



  #----------------------------------------------

  addButtons: (cb) ->
    @addPlayButton()
    @canClick = true

  #----------------------------------------------

  removeButtons: (cb) ->
    @playButton.removeSelf()

    @playButton = null

  #----------------------------------------------

  addPlayButton: (cb) ->
    # log.info @constructor.name, 'addPlayButton'

    return if @playButton?

    btnText = __t.str "Play now"

    options =
      text: btnText
      type: 'primary'
      buttonImage: imageModel.buttonImage if gameModel.hasButtonImage
      buttonHoverImage: imageModel.buttonHoverImage if gameModel.hasButtonImage

    @playButton =  new BaseButton(options)
    @playButton.tapped = (e) => @playButtonClick(e)

    @playButton.order = 0
    layoutManager.placeButton @playButton

    @addChild @playButton

  # -------------------------------------------

  playButtonClick: (e) ->

    @playButton.disable()

    # do we need to show it
    if realityManager.needsToShowRealityCheck
      realityManager.canShowRealityCheck true
      return

    @canClick = false

    window.clearTimeout @timer
    eventManager.trigger 'place-bet'
    e.stopPropagation() if e?

  # -------------------------------------------

  spacebarHit: ->

    @playButtonClick() if @canClick
    return '1234'

  # -------------------------------------------

  willHide:  ->
    @playButton.reset()

  # -------------------------------------------

  didHide: ->

  # -------------------------------------------

  willShow: ->
    @playButton.reset()

    if gameModel.isOutOfTickets() and not gameModel.shouldShowBuyMorePopup()
      @playButton.disable()
      @canClick = false
    else
      @playButton.enable()
      @canClick = true

  # -------------------------------------------

  didShow: ->
    setTimeout(=>
      @playButton.reset()
    ,1)

  # -------------------------------------------

  resize: ->

    layoutManager.repositionY @playButton

    if gameModel.logoFromBottomTitle
      @logo.y = gameModel.rendererHeight - gameModel.logoYTitle

    if @character?
      @character.y = gameModel.rendererHeight - @characterY

    if @tagline?
      @tagline.y = gameModel.rendererHeight - @textY

  # -------------------------------------------

module.exports = MenuView


// WEBPACK FOOTER //
// ./coffee/view/menu-view.coffee